import React from "react";
import AdminModalHeader from "./AdminModalHeader";
import AdminModalBody from "./AdminModalBody";
import AdminModalMsg from "./AdminModalMsg";
import AdminModalFooter from "./AdminModalFooter";
import { observer } from "mobx-react-lite";

const AdminModal = observer((props: any) => (
  <div
    className="modal fade show"
    id={props.modalId}
    tabIndex={-1}
    role="dialog"
    aria-labelledby={props.modalId + "Label"}
    aria-hidden="true"
    style={{ display: "block" }}
  >
    <div className="modal-dialog request-modal" role="document">
      {props.message.status === true ? (
        <AdminModalMsg
          error={props.message.error}
          message={props.message.text}
        />
      ) : null}

      <div className="modal-content request-modal--content">
        <AdminModalHeader
          title={props.modalTitle}
          headerContent={props.headerContent}
        />
        <AdminModalBody bodyContent={props.bodyContent} />
        <AdminModalFooter
          handleRefresh={props.handleRefresh}
          button1={props.footerBtn1}
          button2={props.footerBtn2}
          children={props.footerChildren}
        />
        {props.message.status === true ? (
          <AdminModalMsg
            error={props.message.error}
            message={props.message.text}
          />
        ) : null}
      </div>
    </div>
  </div>
));

export default AdminModal;
